/**
 @ngdoc directive
 @name listingTags

 @description
 listing tags on tiles

 @param {string} url - url link used to get tile tag data
 @param {string} recordUrl - url link that loads tile record page (used when there are too many tags to display on tile, instead suggesting to follow to tile record)

 @example
 <listing-tags ng-if="ctrl.tileData().tagsURI" url="{{ctrl.tileData().tagsURI}}" record-url="{{ctrl.tileData().titleURI}}"></listing-tags>

 */

(function() {
    'use strict';

    var listingTags = function($templateCache, ajaxCall, xmsNotificationFactory) {
        return {
            restrict: "EA",
            scope: true,
            bindToController: {
                /*  '@' Text binding  '=' Two-way binding  '&' Method binding  '<' One-way binding  */
                url: '@',
                recordUrl: "@",
                label: "@",
                tagData: "=",
                loadingCounter: "="
            },
            controllerAs: 'ctrl',
            controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){
                const _this = this;

                // Tile tags settings
                _this.maxInitialTags = 5;
                _this.maxAllTags = 20;
                _this.showAllTags = false;
                _this.loading = true;
                _this.isContentWiderThanWrapper = null;

                // Tag order business logic
                _this.orderedTagTypes = ['ou', 'user', 'other'];

                _this.$onInit = function() {
                    //console.log('listingTags on init', 'url', _this.url, 'loadingCounter', _this.loadingCounter);
                    if (_this.url && !_this.tagData) {
                        ajaxCall.getData(_this.url).then(
                            function(response) {
                                _this.loading = false;
    
                                // Ordering data based on business logic ( ui -> user -> other)
                                if(response.data.result == 'error'){
                                    xmsNotificationFactory.addObj({id: "getTagData", type: response.data.data[0].type, bodyHtml: response.data.data[0].message, timeout:5});
                                }else{
                                    _this.data = reorderData(response.data.data);
                                }
                                _this.loadingCounter++;
                            },
                            function(response) {
                                _this.loading = false;
                                const errorMessage = "Error: " + response.status + ' -  failed to load tag';
                                xmsNotificationFactory.addObj({id: "getTagData", type: 'danger', bodyHtml: errorMessage, timeout:5});
                                _this.loadingCounter++;
                            }
                        );
                    } else {
                        _this.loading = false;
                       
                        if(_this.tagData.data.result == 'error'){
                            xmsNotificationFactory.addObj({id: "getTagData", type: _this.tagData.data.data[0].type, bodyHtml: _this.tagData.data.data[0].message, timeout:5});
                        }else{
                            _this.data = reorderData(_this.tagData.data);
                        }
                    }

                };

                /**
                 * Function that orders response data to the business logic required
                 * @param data
                 * @returns {Array}
                 */
                const reorderData = function(data){
                    let orderedData = [];

                    // Ordering tags to tag types defined in _this.orderedTagTypes
                    _this.orderedTagTypes.forEach(function(tagType) {
                        data.forEach(function(tag) {
                            if (tag.addedBy == tagType){
                                if (tag.searched){
                                    // Getting searched tags in the beginning of the list of orderedData
                                    orderedData.unshift(tag);
                                }else{
                                    orderedData.push(tag);
                                }
                            }
                        });
                    });
                    return orderedData;
                };

                _this.notLoadingAndHasTags = function(){
                    return (!_this.loading && _this.data.length > 0);
                };
                /**
                 * Function that determines if the tag is outside the tag-list boundaries.
                 * @returns {boolean}
                 */
                _this.contentIsWiderThanWrapper = function(){
                    if(!_this.notLoadingAndHasTags()){
                        return false;
                    }
                    if(_this.isContentWiderThanWrapper==null) {
                        const wrapper = $element[0];
                        const content = $element[0].querySelector('.tag-list');
                        const tags = content.querySelectorAll('.tag-item');
                        const lastTag = tags[tags.length - 1];

                        if (!lastTag) {
                            _this.isContentWiderThanWrapper = false;
                        }

                        const wrapperRect = wrapper.getBoundingClientRect();
                        const lastTagRect = lastTag.getBoundingClientRect();

                        if (wrapperRect.right < lastTagRect.right) {
                            _this.isContentWiderThanWrapper = true;
                        } else {
                            _this.isContentWiderThanWrapper = false;
                        }
                    }
                    return _this.isContentWiderThanWrapper;
                }
            }],
            replace: true,
            transclude: false,
            template: $templateCache.get('components/listing/listingTags.html')
        };
    };
    listingTags.$inject = ['$templateCache', 'ajaxCall', 'xmsNotificationFactory'];
    angular.module('app').directive('listingTags', listingTags);

}());